module.exports = __webpack_public_path__ + "img/home-hero-bg2-mobile.4ee7203a.png";